import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useStoreData } from "../../../lib/store/store";
import { Loader } from "../../../components/Loader/Loader";
import { Box } from "@chakra-ui/react";
import { isLoggedIn } from "../../../lib/isLoggedIn";
import { SplashScreen } from "@capacitor/splash-screen";

export const AppLoader = () => {
  const store = useStoreData();
  const { loading } = store;
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading) {
      SplashScreen.hide();
      if (!isLoggedIn(store)) {
        navigate("/app/logged-out");
      } else {
        navigate("/events");
      }
    }
  }, [loading, navigate, store]);
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Loader />
    </Box>
  );
};
